function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21 10h4V4h-2v2h-2V4h-2v2h-2V4h-2v2h-2V4h-2v2H9V4H7v6h4v-.5A1.5 1.5 0 0 1 12.5 8h7A1.5 1.5 0 0 1 21 9.5v.5zm0 2v3a5 5 0 0 1-10 0v-3H9v11a7 7 0 1 0 14 0V12h-2zm2-10h2.5A1.5 1.5 0 0 1 27 3.5v7a1.5 1.5 0 0 1-1.5 1.5H25v11a9 9 0 1 1-18 0V12h-.5A1.5 1.5 0 0 1 5 10.5v-7A1.5 1.5 0 0 1 6.5 2H9V0h2v2h2V0h2v2h2V0h2v2h2V0h2v2zm-10 8v5a3 3 0 1 0 6 0v-5h-6zm3 12a2 2 0 0 1 2 2v2a2 2 0 1 1-4 0v-2a2 2 0 0 1 2-2z"
});

var SvgHaircut = function SvgHaircut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "784bd34b805ac756124cd7cacd5368ad.svg";
export { SvgHaircut as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/haircut.svg
// module id = null
// module chunks = 